import SkyNetTable from 'app/shared-components/SkyNetTable'
import SkyNetDomain, {
    SidebarTab,
} from 'app/shared-components/SkyNetDomain'
import useHasPermission from 'app/hooks/useHasPermission'
import useTabsByPermission from 'app/hooks/useTabsByPermission/useTabsByPermission'
import {
    TableControlTypes,
} from 'app/shared-components/TableControls'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import request from 'app/requests/User.requests'

import tableConfig from './Users.config'
import UserCreate from './UserCreate'
import UserUpdate from './UserUpdate'

const tableControls: TableControlTypes[] = [TableControlTypes.ClearSorting]

const Users = () => {
    const createPermission = useHasPermission(['user_create'])
    const readPermission = useHasPermission(['user_read'])

    const tabs: SidebarTab[] = useTabsByPermission([{
        tab: {
            label: 'Data Update',
            url: CommonRoutes.DataUpdate,
            Component: UserUpdate,
        },
        permission: readPermission,
    }])

    return (
        <SkyNetDomain
            actionComponents={{
                Create: createPermission
                    ? UserCreate
                    : undefined,
            }}
            name={tableConfig.name}
            sidebarTabs={tabs}
        >
            <SkyNetTable
                moduleName={request.domainName}
                tableControls={tableControls}
                tableConfig={tableConfig}
                customUrl={request.getUsers().url}
                showSearch
            />
        </SkyNetDomain>

    )
}

export default Users
